import { jsx as _jsx } from "react/jsx-runtime";
import { PregnancyBabyPageContent, Spinner } from "@madmedical/ui";
import { usePatientId } from "@madmedical/user";
import { useGetPregnancyByPatientQuery } from "../api";
const PregnancyBabyPage = () => {
    const { patientId } = usePatientId();
    const { data: pregnancyData, isLoading } = useGetPregnancyByPatientQuery({
        patientId,
    });
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    if (!pregnancyData) {
        return null;
    }
    return _jsx(PregnancyBabyPageContent, { pregnancyData: pregnancyData });
};
export default PregnancyBabyPage;
